import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import TroubleshootRoundedIcon from '@mui/icons-material/TroubleshootRounded';
import LightRoundedIcon from '@mui/icons-material/LightRounded';
import RouterRoundedIcon from '@mui/icons-material/RouterRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import { Chip } from '@mui/material';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import DeviceHubRoundedIcon from '@mui/icons-material/DeviceHubRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
const items = [
  {
    icon: <ManageAccountsRoundedIcon />,
    title: 'service-management',
    isAdmin: true,
    state: null,
  },
  {
    icon: <TroubleshootRoundedIcon />,
    title: 'operations',
    isAdmin: true,
    state: null,
  },
  {
    icon: <RocketLaunchRoundedIcon />,
    title: 'predictive-heat-control',
    isAdmin: false,
    // state: <Chip variant='outlined' size='small' label="Ny" sx={{ borderRadius: 1, mb: 1, ml: 1, borderColor: 'hsl(63, 100%, 40%)' }} />,
    state: null,
    service: 'PVO',
  },
  // {
  //   icon: <CalendarMonthRoundedIcon />,
  //   title: 'calendar',
  //   isAdmin: false,
  //   state: null,
  //   service: 'PVO',
  // },
  {
    icon: <NotificationsRoundedIcon />,
    title: 'alarms',
    isAdmin: true,
    state: (
      <Chip
        variant="outlined"
        size="small"
        label="New"
        sx={{
          borderRadius: 1,
          mb: 1,
          ml: 1,
          borderColor: 'hsl(63, 100%, 40%)',
        }}
      />
    ),
    // state: <Chip variant='outlined' size='small' label="New" sx={{ borderRadius: 1, mb: 1, ml: 1, borderColor: 'hsl(63, 100%, 40%)' }} />,
  },
  // {
  //   icon: <HomeWorkRoundedIcon />,
  //   title: 'buildings',
  //   isAdmin: true,
  //   state: null,
  // },
  {
    icon: <HomeWorkRoundedIcon />,
    title: 'PVO',
    isAdmin: true,
    state: null,
  },
  // {
  //   icon: <SubscriptionsRoundedIcon />,
  //   title: 'subscriptions',
  //   isAdmin: true,
  //   path: '/buildings/subscriptions',
  //   state: null,
  // },
  {
    icon: <DeviceHubRoundedIcon />,
    title: 'datahub-integration',
    isAdmin: false,
    state: null,
    service: 'DatahubIntegration',
  },
  {
    icon: <ApartmentRoundedIcon />,
    title: 'portfolio-analysis-hub',
    isAdmin: false,
    state: null,
    service: 'PortfolioAnalysis',
  },
  {
    icon: <BoltRoundedIcon />,
    title: 'energyxplorer',
    isAdmin: false,
    state: null,
    service: 'EnergyXplorer',
  },
  {
    icon: <AssessmentIcon />,
    title: 'monitor',
    isAdmin: false,
    scopes: '',
    state: null,
  },
  // {
  //   icon: <QueryStatsRoundedIcon />,
  //   title: 'Data Tools',
  //   // state: <Chip variant='outlined' size='small' label="New" sx={{ borderRadius: 1, borderColor: 'hsl(63, 100%, 40%)' }} />,
  //   label: t('glossary:data-tools'),
  //   description:
  //     'Access and analyze your data with our powerful data analysis toolset.',
  // },
  {
    icon: <DashboardRoundedIcon />,
    title: 'dashboards',
    isAdmin: true,
    state: null,
  },
  {
    icon: <LightRoundedIcon />,
    title: 'units',
    isAdmin: true,
    service: 'Basis',
    // state: <Chip variant='outlined' size='small' label="New" sx={{ borderRadius: 1, borderColor: 'hsl(63, 100%, 40%)' }} />,
  },
  {
    icon: <RouterRoundedIcon />,
    title: 'gateways',
    isAdmin: true,
    service: 'Basis',
    // state: <Chip variant='outlined' size='small' label="New" sx={{ borderRadius: 1, borderColor: 'hsl(63, 100%, 40%)' }} />,
  },
  {
    icon: <SpeedRoundedIcon />,
    title: 'sensors',
    isAdmin: true,
    service: 'Basis',
    // state: <Chip variant='outlined' size='small' label="New" sx={{ borderRadius: 1, borderColor: 'hsl(63, 100%, 40%)' }} />,
  },
  {
    icon: <BarChartRoundedIcon />,
    title: 'view-data',
    isAdmin: true,
    service: 'Basis',
    // state: <Chip variant='outlined' size='small' label="New" sx={{ borderRadius: 1, borderColor: 'hsl(63, 100%, 40%)' }} />,
  },
  {
    icon: <SupportAgentRoundedIcon />,
    title: 'support',
    isAdmin: false,
    state: null,
  },
];

export default items;
